import { Box, Button, FormControl, FormHelperText, Grid, Paper, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";
import { useAddDocumentoHistoricoMutation } from "./DocumentoAtualizarAndamentoApiSlice";
import { DocumentoAtualizaAndamento, ISdocumentoAtualizaAndamento } from "../../../types/documento/andamentoHistorico/DocumentoAtualizaAndamento";
import { DocumentoAtualizaAndamentoDTO } from "../../../types/documento/andamentoHistorico/DocumentoAtualizaAndamentoDTO";
import { Documento, ISdocumento } from "../../../types/processo/Documento";
import { useGetDocumentoQuery } from "../createDocumento/documentoApiSlice";


export const DocumentoAtualizarAndamentoCreate = () => {

    const [documentoAtualizaAndamento, SetDocumentoAtualizaAndamento] = useState<DocumentoAtualizaAndamento>(ISdocumentoAtualizaAndamento);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createHistorico, status] = useAddDocumentoHistoricoMutation();
    const navigate = useNavigate();

    // Hook para seleção do documento
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum documento foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);


    const id = useParams().id || "";
    const [documento, setDocumento] = useState<Documento>(ISdocumento);
    const { data: dataDoc, isFetching: isFetchingDoc, error: errorDoc } = useGetDocumentoQuery(id || "");
    useEffect(() => {
        if (dataDoc) {
            setDocumento(dataDoc);
        } else if (errorDoc) {
            enqueueSnackbar("Documento não encontrado!", { variant: "error" });
            window.location.href = configUrls.PROCESSO_LIST_RT;
        } else if (isFetchingDoc) {
            enqueueSnackbar("Buscando registro...", { variant: "info" });
        } else {
            enqueueSnackbar("Documento não encontrado!", { variant: "error" });
            window.location.href = configUrls.PROCESSO_LIST_RT;
        }
    }, [dataDoc, errorDoc, isFetchingDoc]);




    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        SetDocumentoAtualizaAndamento((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const parms: DocumentoAtualizaAndamentoDTO = {
            id: documentoAtualizaAndamento.id,
            descricao: documentoAtualizaAndamento.descricao,
            documentoID: documento ? documento.id : "",
        }
        await createHistorico(parms);
    }

    useEffect(() => {

       

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);








    return (



        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Atualizar Andamento do documento: {documento.nomeArvore}
                </Typography>
                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        label="Descricão:"
                                        name="descricao"
                                        onChange={handleChange}
                                        size="small"
                                        inputProps={{ maxLength: 255 }}
                                        value={documentoAtualizaAndamento.descricao}
                                        multiline  // Adiciona o suporte a múltiplas linhas
                                        rows={4} />


                                    <FormHelperText>
                                        {documentoAtualizaAndamento.descricao?.length}/255 caracteres
                                    </FormHelperText>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>



                </Box>




            </Paper>










        </>







    );










};